export default __webpack_public_path__ + "static/media/hamburger_icon.309593fe.svg";